<mat-card class="p-0">
	<mat-card-content>
		<div *ngIf="!isLoadingBrokersSearch && IS_EMPTY(brokerSearchString)">
			<h2 class="p-1 py-0 mb-0 label-text-light">Recently Updated Brokers</h2>
			<div class="p-1 py-0 label-text-light" fxLayout="row">
				Showing the most recently updated brokers
			</div>
		</div>

		<div *ngIf="isLoadingBrokersSearch && IS_NULL_OR_UNDEFINED(brokersList)" class="m-t-1 m-b-1">
			<app-default-progress-bar> </app-default-progress-bar>
		</div>

		<div *ngIf="!isLoadingBrokersSearch && IS_NOT_NULL_OR_UNDEFINED(brokersList)" class="p-1">
			<h2
				*ngIf="brokersList.length > 0 && IS_NOT_EMPTY(brokerSearchString)"
				class="py-0 mb-0 label-text-light"
			>
				Matching Brokers
			</h2>
			<h2 *ngIf="brokersList.length == 0" class="py-0 mb-0 label-text-light">
				No matching brokers found for the search.
			</h2>

			<mat-card
				*ngFor="let broker of brokersList; let cIndex = index"
				class="m-t-1 cursor-pointer m-b-0"
			>
				<mat-card-content class="primary-text font-size-14">
					<div fxLayout="row">
						<div class="ellipsis" fxFlex="50" fxLayoutAlign="start center">
							<b>
								<span [innerHTML]="broker.businessName | highlightText: brokerSearchString"></span>
							</b>
						</div>
						<div fxFlex="25" fxLayoutAlign="center center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(broker.mc)">
								<b>MC:</b>&nbsp;<span
									[innerHTML]="broker.mc | highlightText: brokerSearchString"
								></span>
							</span>
						</div>
						<div fxFlex="25" fxLayoutAlign="end center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(broker.dot)">
								<b>DOT:</b>&nbsp;<span
									[innerHTML]="broker.dot | highlightText: brokerSearchString"
								></span>
							</span>
						</div>
					</div>
					<div class="m-t-0-6" fxLayout="row">
						<div fxFlex="50" fxLayoutAlign="start center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(broker.contactName)">
								<b>Contact:</b>&nbsp;{{ broker.contactName }}
							</span>
						</div>
						<div fxFlex="25" fxLayoutAlign="center center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(broker.contactEmail)">
								{{ broker.contactEmail }}
							</span>
						</div>
						<div fxFlex="25" fxLayoutAlign="end center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(broker.contactPhone)">
								{{ broker.contactPhone }}
							</span>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</mat-card-content>
</mat-card>
